/**
 * @component {"type":"CheckboxMinMax","version":"1.0"}
 */
define('helperMisc-validate',['jquery', 'helperContent-componentObject', 'helperUser-getMultipleChoiceSelectedOptionsCount'], function($, componentObject, getMultipleChoiceSelectedOptionsCount) {
	'use strict';

	return function(vm) {
		var id			= '',
			el			= null,
			val			= '',
			count		= 0,
			answers		= [],
			questions	= [],
            isValidEmail = function(email) {
                var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
                return re.test(email);
            };

		switch (vm.typeId()) {

        case 12: // Open Question
            questions = vm.questions();
            answers = vm.answers();

            if ( answers && answers.length ) {
                answers.forEach(function(element) {
                    id = element.id();
                    el = document.getElementById(id);

                    if (el) {
                        $(el).removeClass('f-email-correct f-email-incorrect');

                        val = $.trim( el.value );

                        if (el.type === 'email' && val && val !== '-') {
                            if (isValidEmail(val)) {
                                $(el).addClass('f-email-correct');
                                count += 1;
                            } else {
                                $(el).addClass('f-email-incorrect');
                            }
                        } else if (val) {
                            count += 1;
                        }
                    }

                });

                if ( vm.allAnswersRequired() && count === answers.length || !vm.allAnswersRequired() && count !== 0 ) { // all inputs filled required
                    return true;
                }

            } else if ( questions && questions.length ) {
                questions.forEach(function(element) {
                    id = element.id();
                    el = document.getElementById(id);

                    if (el) {
                        val = $.trim( el.value );
                        if ( val ) {
                            count += 1;
                        }
                    }

                });

                if ( vm.allAnswersRequired() && count === questions.length || !vm.allAnswersRequired() && count !== 0 ) {
                    return true;
                }

            }

            return false;
		case 13: // MultiChoice

			switch (vm.displayMode()) {
			case 2: //radio

                answers = vm.answers();
                count = getMultipleChoiceSelectedOptionsCount(answers);

                // at least 1 answer
                var res = (count > 0) ? true : false;
                return res;

			case 3: //checkbox

				answers = vm.answers();
                count = getMultipleChoiceSelectedOptionsCount(answers);

                // at least 1 answer
                var res = (count > 0) ? true : false;

                var comps = componentObject.getComponentsByKind(vm, "CheckboxMinMax");
                if(res && comps && comps.length > 0){
                    // there might be minAnswers & maxAnswers

                    var comp = comps[0];
                    if(!comp.content.alert || comp.content.alert.replace(/(<([^>]+)>)/ig, '') == '' || comp.content.alert.replace(/(<([^>]+)>)/ig, '') == ' ') {
                        // if alert text not defined, use min and max in validation (enabling submit)
                        var min = comp.content.min,
                            max = comp.content.max;
                        if (min) {
                            if (min > count){
                                res = false;
                            }
                        }
                        if (max) {
                            if (max < count){
                                res = false;
                            }
                        }
                    }
                }
				return res;

			case 4: //buttons

				break;
			case 5: //dropdown list

				break;
			default:
				return false;
			}

			break;
		case 14: // Yes No
			questions = vm.questions();

			if ( questions && questions.length ) {

                switch (vm.displayMode()) {
                case 2: // radio
                    questions.forEach(function(element) {
                        id = element.id();

                        if ( $('input[name="' + id + '"]:checked').length ) {
                            count += 1;
                        }
                    });

                    return (count === questions.length) ? true : false;
                case 8: // boxes
                    questions.forEach(function(element) {
                        id = element.id();

                        if ( $('input[name="' + id + '"]').val() ) {
                            count += 1;
                        }
                    });

                    return (count === questions.length) ? true : false;
                default:
                    return false;
                }
			}

			return false;
		case 15: // Set in Order
			questions = vm.questions();

            if ( questions && questions.length ) {
                questions.forEach(function(question) {
                    var ID = question.id(),
                        node = document.getElementById(ID);

                    if (node && node.value) {
                        count += 1;
                    }
                });

                if (count === questions.length) {
                    return true;
                }
            }

			return false;
		case 16: // Match Pair
			questions = vm.questions();

            questions.forEach(function(question) {
                var ID = question.id(),
                    node = document.getElementById(ID);

                if (node && node.dataset && node.dataset.id) {
                    count += 1;
                }
            });

            if (count === questions.length) {
                return true;
            }

            // Draggable
            answers = vm.answers();

            if ( answers && answers.length ) {
                answers.forEach(function(element) {
                    if ($('#' + element.id()).has('.js-drag-item').length) {
                        count += 1;
                    }
                });

                if (count === answers.length) {
                    return true;
                }
            }
            // END Draggable

			return false;
		case 17: // Evaluate

			questions = vm.questions();

			if ( questions && questions.length ) {
				questions.forEach(function(element) {
					id = element.id();

					if ( $('input[name="' + id + '"]:checked').length ) {
						count += 1;
					}
				});

				if (count === questions.length) {
					return true;
				}
			}

			return false;
		case 18: // Fill Blanks

			questions = vm.questions();

			if ( questions && questions.length ) {
				questions.forEach(function(element) {
					el = document.getElementById(element.id());
					if ( el && !el.value ) {
						count += 1;
					}
				});

				if ( count === 0 ) {
					return true;
				}
			}

			return false;
		case 19: // Quiz

			// Need validation of quiz
			// pass quiz answers to server

			return true;
		case 20: // Sort to Groups
			answers = vm.answers();
			questions = vm.questions();

			if ( questions && questions.length ) {
				questions.forEach(function(element) {
					count += $('#' + element.id()).find('.js-sort-answer').length;
				});

				if (count === answers.length) {
					return true;
				}
			}

			return false;

		default:
			return false;
		}

		return false;

	};

});

